var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{staticClass:"main"},[(_vm.setco)?_c('Header'):_vm._e(),_c('router-view',{staticClass:"content-wrap"})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }